import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { CompaniesService } from "../companies/companies.service";
import { ApiService } from "../shared";
import { ProjectsService } from "../projects/projects.service";
import { ConfigService } from "../config.service";
import * as Joi from "joi";

@Injectable()
export class AlertsService {
  static currentAlert: any;
  private serviceUrl = ConfigService.serviceUrl;
  private alertSchema: Joi.Schema = Joi.object().keys({
    active: Joi.bool().required(),
    type: Joi.string().min(1).required(),
    context: Joi.object().required().keys({
      project_ids: Joi.array().required(),
      employer_ids: Joi.array().required(),
      nationalities: Joi.array().required(),
      countries: Joi.array().required(),
      program_id: Joi.string()
    }),
    default_lang: Joi.string().min(1).required(),
    content: Joi.object()
      .min(1)
      .required()
      .keys(
        ConfigService.languages.reduce((obj, curr) => {
          obj[curr.key] = Joi.object().keys({
            author: Joi.string(),
            title: Joi.string().min(1).required(),
            description: Joi.string().min(1).required()
          });
          return obj;
        }, {})
      ),
    id: Joi.string(),
    created_at: Joi.date(),
    updated_at: Joi.date(),
    author_id: Joi.string(),
    user_id: Joi.string(),
    company_id: Joi.string(),
    author_image: Joi.string(),
    author_type: Joi.string(),
    author: Joi.string()
  });

  constructor(
    private http: Http,
    private companiesService: CompaniesService,
    private apiService: ApiService,
    private projectsService: ProjectsService
  ) {}

  getAlerts(): Observable<any> {
    return this.http
      .get(`${this.serviceUrl}/alerts`)
      .map((res) => {
        return this.extractData(res, true);
      })
      .catch(this.handleError);
  }

  getProjects(): Observable<any> {
    return this.projectsService.getProjectList();
  }

  getNationalities(): any[] {
    return ConfigService.countryList;
  }

  getEmployers(): Observable<any> {
    return this.companiesService.getEmployers();
  }

  createAlert(alert: any): Observable<any> {
    return Observable.create((observer) => {
      Joi.validate(alert, this.alertSchema, (err, v) => {
        if (err) {
          observer.error(err);
          observer.complete();
        } else {
          this.http.post(`${this.serviceUrl}/alerts`, alert).subscribe(
            (resp) => {
              observer.next(this.extractData(resp, null));
              observer.complete();
            },
            (error) => {
              observer.error(this.handleError(error));
              observer.complete();
            }
          );
        }
      });
    });
  }

  editAlert(alert: any): Observable<any> {
    return Observable.create((observer) => {
      Joi.validate(alert, this.alertSchema, (err, v) => {
        if (err) {
          observer.error(err);
          observer.complete();
        } else {
          this.http
            .put(`${this.serviceUrl}/alerts/` + alert.id, alert)
            .subscribe(
              (resp) => {
                observer.next(this.extractData(resp, null));
                observer.complete();
              },
              (error) => {
                observer.error(this.handleError(error));
                observer.complete();
              }
            );
        }
      });
    });
  }

  deleteAlert(id: string): Observable<any> {
    return this.http.delete(`${this.serviceUrl}/alerts/` + id).map(
      (resp) => {},
      (error) => {
        this.handleError(error);
      }
    );
  }

  getProjectNames(alerts: any[]) {
    this.projectsService.getProjectList().subscribe((projectList) => {
      alerts.map((alert) => {
        alert.context.projectNames = [];
        if (alert.context.project_ids.length < 1) {
          alert.context.projectNames = ["<any>"];
        } else {
          alert.context.project_ids.map((id) => {
            let projects = projectList.filter((it) => {
              return it.id === id;
            });
            if (projects.length > 0) {
              alert.context.projectNames.push(projects[0].name);
            }
          });
        }
      });
    });
  }

  getCountryNames(ids: string[]): string[] {
    let names = ApiService.getCountryNames(ids);
    if (names.length > 0) {
      return names;
    }
    return ["<any>"];
  }

  getLanguages(): any[] {
    return ConfigService.languages;
  }

  getAlertTypes(): any[] {
    return ConfigService.alertTypes;
  }

  getEmployerNames(alerts: any[]) {
    this.companiesService.getEmployers().subscribe((employerList) => {
      alerts.map((alert) => {
        alert.context.employerNames = [];
        if (alert.context.employer_ids.length < 1) {
          alert.context.employerNames = ["<any>"];
        } else {
          alert.context.employer_ids.map((id) => {
            let employers = employerList.filter((it) => {
              return it.id === id;
            });
            if (employers.length > 0) {
              alert.context.employerNames.push(employers[0].name);
            }
          });
        }
      });
    });
  }

  getItemsPerPageValues(): number[] {
    return ConfigService.itemsPerPageValues;
  }

  getItemsPerPage(): number {
    return ApiService.getItemsPerPage();
  }

  saveItemsPerPage(value: number) {
    ApiService.saveItemsPerPage(value);
  }

  private extractData(res: Response, getNames: boolean) {
    let body = res.json();
    if (getNames) {
      this.getProjectNames(body);
      this.getEmployerNames(body);
    }
    if (Array.isArray(body)) {
      body.forEach((it) => {
        it.context.countries = it.context.countries || [];
      });
    } else {
      body.context.countries = body.context.countries || [];
    }
    return body;
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/alerts/alerts.service.ts